const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const obj = {
  tableName: "blogsCategory",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: true, //for enabiling comments on view and edit
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "name",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.required],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "slug",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "priority",
      type: types.INTEGER,
      validation: [validatorTypes.string, validatorTypes.optional],
      // unique: true,
      ui: {
        // added for ui
        type: uiTypes.NUMBER, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "enabled",
      type: types.BOOLEAN,
      validation: [validatorTypes.bool, validatorTypes.optional],
      // unique: true,
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "subcategory_name",
      type: types.STRING,
      isArray: false,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
